"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessControl = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Class for governing access control
 * against a given attribute or role
 */
var AccessControl =
/*#__PURE__*/
function () {
  function AccessControl(rule_defs) {
    _classCallCheck(this, AccessControl);

    this.init(rule_defs);
  }
  /**
   * Process and store rule definitions
   * @param  {Object} rule_defs Rule definitions
   */


  _createClass(AccessControl, [{
    key: "init",
    value: function init(rule_defs) {
      /**
       * Expect input type to be an object
       * Role definition can be found in README.md
       */
      if (_typeof(rule_defs) !== 'object') {
        throw new TypeError('Expected an object as input.');
      }

      var roles = {}; // Process rule definitions

      Object.keys(rule_defs).forEach(function (role_key) {
        // Create an entry for a given role
        roles[role_key] = {
          can: {}
        };

        if (!rule_defs[role_key].can) {
          throw new TypeError("Missing 'can' definition on role: ".concat(role_key));
        } // Assign permissions to roles


        rule_defs[role_key].can.forEach(function (operation) {
          if (typeof operation === 'string') {
            // Simple resource definition
            roles[role_key].can[operation] = true;
          } else {
            throw new TypeError('Invalid entry in rule definitions.');
          }
        });
      }); // Save rule definitions to instance

      this.roles = roles;
    }
    /**
     * Escape all necessary characters
     * @param  {string} str String to escape
     * @return {string} Escaped string
     */

  }, {
    key: "checkRole",
    value: function checkRole(role, operation) {
      // Get the definition for this role
      var $role = this.roles[role]; // If the role definition exists

      if (!$role) {
        return false;
      }

      if ($role.can[operation]) {
        // Check is necessary for future functionality
        // Can't currently check because role init
        // only creates booleans

        /* istanbul ignore next */
        if (typeof $role.can[operation] === 'boolean') {
          // If the permission exists on the map,
          // there's no need to check for wildcards.
          return true;
        }
      } // Check for wildcards


      var permissions = Object.keys($role.can);

      for (var i = 0; i < permissions.length; i += 1) {
        var permission = permissions[i]; // Check if the supplied operation matches the wildcarded permission

        if (operation.match(AccessControl.wildcardToRegExp(permission))) {
          return true; // Short circuit
        }
      }

      return false;
    }
    /**
     * [can description]
     * @param  {[type]} context   [description]
     * @param  {[type]} operation [description]
     * @return {[type]}           [description]
     */

  }, {
    key: "can",
    value: function can(context, operation) {
      var _this = this;

      if (!context) {
        throw TypeError('The context argument is required.');
      }

      if (!context.user) {
        throw TypeError('No user supplied via context.');
      }

      if (!context.user.roles) {
        throw TypeError('No roles on user object.');
      }

      if (!operation) {
        throw TypeError('The operation argument is required.');
      }
      /**
       * TODO: Add support for wildcards in can()
       * Example: AccessControl.can(context, 'store:*')
       */


      if (operation.indexOf('*') > -1) {
        throw new TypeError('Wildcards are not yet supported via the can() query.');
      }

      var user_roles = context.user.roles;
      var checks = user_roles.map(function (role) {
        return _this.checkRole(role, operation);
      });
      return checks.some(function (pass) {
        return pass === true;
      });
    }
  }], [{
    key: "regExpEscape",
    value: function regExpEscape(str) {
      return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    }
    /**
     * Create RegExp from a given string,
     * where asterisk is a wildcard
     * @param  {string} str String to convert into a RegExp
     * @return {RegExp}     [description]
     */

  }, {
    key: "wildcardToRegExp",
    value: function wildcardToRegExp(str) {
      return new RegExp("^".concat(str.split(/\*+/).map(this.regExpEscape).join('.*'), "$"));
    }
  }]);

  return AccessControl;
}(); // eslint-disable-next-line import/prefer-default-export


exports.AccessControl = AccessControl;



//////////////////
// WEBPACK FOOTER
// ../access-control/lib/index.js
// module id = NVkp
// module chunks = 56